export default __webpack_public_path__ + "static/media/Dashboard.cd4d4218.PNG";